import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "../store/index"
Vue.use(VueRouter)

// 添加登录页面组件映射
const LOGIN_COMPONENTS = {
  'test-liumai.nextedc.cn': () => import('@/views/login/login.vue'),
  'liumai.nextedc.cn': () => import('@/views/login/login.vue'),
  'test-liumai-a.nextedc.cn': () => import('@/views/login/logina.vue'),
  'liumai-a.nextedc.cn': () => import('@/views/login/logina.vue'),
  'localhost': () => import('@/views/login/login.vue'),
  // '192.168.3.66': () => import('@/views/login/logina.vue'),
}

const routes = [
  { path: '/', redirect: '/login' },
  { 
    path: '/login',
    // 修改登录组件为动态加载
    component: () => {
      const hostname = window.location.hostname;
      const loginComponent = LOGIN_COMPONENTS[hostname];
      // 如果找不到对应域名的登录组件，使用默认登录组件
      return loginComponent ? loginComponent() : import('@/views/login/login.vue');
    }
  },
  {
    path: '/leadershipmanagement/bigscreenNew',
    component: () => import('@/views/leadershipmanagement/bigscreenNew.vue'),
    meta: { title: '首页', icon: 'home', menuKey: '1', menu: true },
  },
  {
    path: '/leadershipmanagement/bigscreen',
    component: () => import('@/views/leadershipmanagement/bigscreen.vue'),
    meta: { title: '首页', icon: 'home', menuKey: '1', menu: true },
  },
  {
    path: '/layout',
    component: () => import('@/views/layout/index.vue'),
    children: [
      { path: '/', redirect: '/projectManagement/QuestionnaireItems' },
      {
        path: '/Userinfo/PersonalInformation',
        component: () => import('@/views/Userinfo/Personalinformation.vue'),
      }, {
        path: '/Userinfo/Changpassword',
        component: () => import('@/views/Userinfo/Changpassword.vue')
      },
      {
        path: '/Systemmessages/myinfo',
        component: () => import('@/views/Systemmessages/myinfo.vue')
      },
      {
        path: '/Systemmessages/Messagemanagement',
        component: () => import('@/views/Systemmessages/Messagemanagement.vue')
      },
      {
        path: '/Systemmessages/newinfo',
        component: () => import('@/views/Systemmessages/newinfo.vue')
      },

      // 领导管理
      {
        path: '/leadershipmanagement/Piechart',  //饼图
        component: () => import('@/views/leadershipmanagement/Piechart.vue'),
        meta: { title: '领导管理', menuKey: '1.1'},
      },
      {
        path: '/leadershipmanagement/IndicatorStatistics',  //指标
        component: () => import('@/views/leadershipmanagement/IndicatorStatistics.vue')
      },
      {
        path: '/leadershipmanagement/quotaInfo',  //配额
        component: () => import('@/views/leadershipmanagement/quotaInfo.vue')
      },
      // 项目管理
      {
        path: '/projectManagement/QuestionnaireItems',   // 项目问卷
        component: () => import('@/views/projectManagement/QuestionnaireItems.vue'),
        meta: { title: '首页', icon: 'home', menuKey: '2', menu: true },
      },
      // 受访者库
      {
        path: '/Respondentpool/Itemlist',   //受访者列表
        component: () => import('@/views/Respondentpool/Itemlist.vue'),
        meta: { title: '受访者列表', icon: 'home', menuKey: '3.1', menu: true },

      },
      {
        path: '/Respondentpool/IntervieweeReviewList',   //受访者审核列表
        component: () => import('@/views/Respondentpool/IntervieweeReviewList.vue'),
        meta: { title: '受访者审核列表', icon: 'home', menuKey: '3.2', menu: true },
      },
      {
        path: '/Respondentpool/SampleLibraryReport',   //样本库报表
        component: () => import('@/views/Respondentpool/SampleLibraryReport.vue'),
        meta: { title: '样本库报表', icon: 'home', menuKey: '3.3', menu: true },
      },
      {
        path: '/Respondentpool/ClassificationList',   //分类列表
        component: () => import('@/views/Respondentpool/ClassificationList.vue'),
        meta: { title: '分类列表', icon: 'home', menuKey: '3.4', menu: true },
      },
      {
        path: '/Respondentpool/DepartmentList',   //部门列表
        component: () => import('@/views/Respondentpool/DepartmentList.vue'),
        meta: { title: '部门列表', icon: 'home', menuKey: '3.5', menu: true },
      },
      // 短信发送
      {
        path: '/textmessage/Scheduledtasks',   //定时任务
        component: () => import('@/views/textmessage/Scheduledtasks.vue'),
        meta: { title: '定时任务', icon: 'home', menuKey: '4.1', menu: true },
      },
      {
        path: '/textmessage/txtmesage',   //发送短信
        component: () => import('@/views/textmessage/txtmesage.vue'),
        meta: { title: '发送短信', icon: 'home', menuKey: '4.2', menu: true },
      },
      {
        path: '/textmessage/Commontask',   //普通任务
        component: () => import('@/views/textmessage/Commontask.vue'),
        meta: { title: '普通任务', icon: 'home', menuKey: '4.3', menu: true },
      },
      {
        path: '/textmessage/Senddetailedorder',   //发送详单
        component: () => import('@/views/textmessage/Senddetailedorder.vue'),
        meta: { title: '发送详单', icon: 'home', menuKey: '4.4', menu: true },
      },

      // 设置中心
      {
        path: '/setfocus/SystemOperationLog',   //系统操作日志
        component: () => import('@/views/setfocus/SystemOperationLog.vue'),
        meta: { title: '发送详单', icon: 'home', menuKey: '5.1', menu: true },
      },
      {
        path: '/setfocus/UserGroupManagement',   //用户组管理
        component: () => import('@/views/setfocus/UserGroupManagement.vue'),
        meta: { title: '发送详单', icon: 'home', menuKey: '5.2', menu: true },
      },
      {
        path: '/setfocus/knowledgebase',   //知识库
        component: () => import('@/views/setfocus/knowledgebase.vue'),
        meta: { title: '发送详单', icon: 'home', menuKey: '5.3', menu: true },
      },

      {
        path: '/setfocus/BureauNumberLibraryList',   //局号库列表
        component: () => import('@/views/setfocus/BureauNumberLibraryList.vue'),
        meta: { title: '局号库列表', icon: 'home', menuKey: '5.4', menu: true },
      },
      {
        path: '/setfocus/ListeningRecordings',   //调听录音
        component: () => import('@/views/setfocus/ListeningRecordings.vue'),
        meta: { title: '调听录音', icon: 'home', menuKey: '5.5', menu: true },
      },
      {
        path: '/setfocus/datadictionary',   //数据字典
        component: () => import('@/views/setfocus/datadictionary.vue'),
        meta: { title: '数据字典', icon: 'home', menuKey: '5.6', menu: true },
      },
      {
        path: '/setfocus/loginLog',   //登录日志
        component: () => import('@/views/setfocus/loginLog.vue'),
        meta: { title: '登录日志', icon: 'home', menuKey: '5.7', menu: true },
      },
      {
        path: '/setfocus/CustomInformation',   //自定义受访者信息
        component: () => import('@/views/setfocus/CustomInformation.vue'),
        meta: { title: '自定义受访者信息', icon: 'home', menuKey: '5.8', menu: true },
      },
      // 组织管理
      {
        path: '/OrganizationalManagement/Department',   //部门管理
        component: () => import('@/views/OrganizationalManagement/Department.vue'),
        meta: { title: '部门管理', icon: 'home', menuKey: '6.1', menu: true },
      },
      {
        path: '/OrganizationalManagement/personnelManagement',   //人员管理
        component: () => import('@/views/OrganizationalManagement/personnelManagement.vue'),
        meta: { title: '人员管理', icon: 'home', menuKey: '6.2', menu: true },
      },
      // {
      //   path: '/OrganizationalManagement/videoChatview',   //视频聊天
      //   component: () => import('@/views/OrganizationalManagement/videoChatview.vue'),
      //   meta: { title: '视频聊天', icon: 'home', menuKey: '6.3', menu: true },
      // },
      {
        path: '/OrganizationalManagement/Modifypermissions',   //权限修改
        component: () => import('@/views/OrganizationalManagement/Modifypermissions.vue')
      },
      {
        path: '/OrganizationalManagement/newCreateRole',   //新增角色
        component: () => import('@/views/OrganizationalManagement/newCreateRole.vue')
      },
      // 监控管理
      {
        path: '/MonitoringManagement/TrafficMonitoring',   //人员监控
        component: () => import('@/views/MonitoringManagement/TrafficMonitoring.vue'),
        meta: { title: '人员监控', icon: 'home', menuKey: '7.1', menu: true },
      },



    ],

  },
]




const router = new VueRouter({
  // mode:'history',
  routes,
})
// router.beforeEach((to, from, next) => {
//   let Token = localStorage.getItem("Token");
//   // 判断当前页面是否为首页
//   if (to.path !== '/login') {
//     // 如果存储中有 UserToken
//     if (Token) {
//       // 放行
//       next();
//     } else {
//       // 如果没有 UserToken，重定向到登录页
//       next({
//         path: "/login"
//       });
//     }
//   } else {
//     // 如果不是首页，放行
//     next();
//   }
// })
export default router
